// Arabic naming for the WhatsApp templates this account uses.
//
// Meta template names are ASCII-only, so the agent-facing Arabic wording lives
// here instead of in the i18n catalogs: it is business data that changes when a
// template is created or replaced on Meta, not app copy that gets translated.
// Unknown template names simply fall back to the raw Meta name.

export const AR_TITLES = {
  reason_for_order_rejection: 'سبب رفض الشحنة',
  request_an_invoice: 'إرسال الفاتورة',
  calling_problem: 'بنحاول نتصل ومفيش رد',
  inquiry_followup: 'متابعة استفسار',
  shipping_agent_contact_v5: 'مندوب الشحن بيحاول يوصلك',
  the_teacher_address1: 'طلب عنوان وبيانات المدرس',
  order_confirmation_eltafouk: 'تأكيد الأوردر',
  order_confirmation_pickup_eltafouk: 'تأكيد الأوردر — استلام مخزن',
  gift_order_confirmation_v3: 'تأكيد أوردر الهدية',
  invoice_shipped_tracked: 'تم الشحن — بكود تتبع',
  invoice_shipped_plain: 'تم الشحن — بدون كود',
  invoice_shipped_eltafouk: 'تم الشحن — نسخة قديمة',
  invoice_shipped_eltafouk_v2: 'تم الشحن — نسخة قديمة v2',
  invoice_collected_eltafouk: 'تم الاستلام من المخازن',
  gift_shipped_eltafouk: 'شحن هدية مدرس',
  gift_collected_v2: 'استلام هدية من المخزن',
  missed_call_workhours_v2: 'مكالمة فايتة — مواعيد الشغل',
  missed_call_afterhours_v2: 'مكالمة فايتة — خارج المواعيد',
  bio_books_offer_2027_v3: 'حملة كتب الأحياء 2027',
  chem_book_offer_2027: 'إعلان توفر كتاب الكيمياء 2027',
  phys_book_offer_2027: 'إعلان توفر كتاب الفيزياء 2027',
  hello_world: 'قالب ميتا التجريبي',
  order_confirmed_ar: 'المتجر: تأكيد طلب',
  order_delivered_ar: 'المتجر: تم التسليم',
  order_shipped_ar: 'المتجر: خرج للتوصيل',
  cod_confirm_ar: 'المتجر: تأكيد الدفع عند الاستلام',
  review_request_ar: 'المتجر: طلب تقييم',
};

// What each body variable actually means, keyed by template name then by the
// variable number Meta uses ({{1}}, {{2}}, ...). Without this the agent only
// sees "المتغيرات" and has to guess what to type.
export const AR_VARIABLE_LABELS = {
  shipping_agent_contact_v5: { 1: 'رقم المندوب' },
};

export const templateArabicTitle = name => AR_TITLES[name] || name;

export const hasArabicTitle = name => Boolean(AR_TITLES[name]);

export const templateVariableLabel = (name, key) =>
  AR_VARIABLE_LABELS[name]?.[key];
